export default __webpack_public_path__ + "static/media/add-icon.6edb4e3e.svg";